module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAMAAABgOjJdAAAATlBMVEUAAAD////////////////////////////////////////////////////////////Ozs48PDxtbW2enp7n5+fz8/PCwsLa2tq2trZ5eXmLGKMOAAAAD3RSTlMAr4DvQCDPvxBQMJ9wYN9cwFqkAAAAn0lEQVQ4y82TSw7DIAwFbTB/6KNN0s/9L1pVqMoCyV2lyqxnwRtkwi/+aVysblghSlYzWmbOTTOIASY8bzN9GLEAJaLPwmsdhom1RqNuMdmZ44vZUqxq+EgUvWZIApIAfeLxLRaAQFiuM/dhfKYah7XPbMNgyplY3eJr9ccXC60F1WAS0V66r11mtr0Yq8UkWZtE/TlH5Ly+NvA57lbjDQ8QPZOKmxDfAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/pinpai.png
// module id = 81RE
// module chunks = 4